import React from 'react'

import Reflux from 'reflux-react-16'
import moment from 'moment'

import AdminStore from '../../stores/AdminStore.js'
import AdminActions from '../../actions/AdminActions.js'
import LoginActions from '../../actions/LoginActions.js'

import {Button, Colors, IconButton, Panel, Popup, Row} from '../../components/UI/index.js'
import {formSpacing, Input} from '../../components/UI/forms/index.js'
import Table from '../../components/UI/table/index.js'
import createMemo from '../../utils/createMemo.js'

// TODO store this in a central place
const webshopKeyToName = {
    bolcom: 'Bol.com',
    lightspeed: 'Lightspeed',
    shopify: 'Shopify',
    woocommerce: 'WooCommerce',
    prestashop: 'PrestaShop',
    magento: 'Magento',
    ccvshop: 'CCV Shop',
    mijnwebwinkel: 'Mijnwebwinkel',
    shoptrader: 'Shoptrader',
    snelstart: 'SnelStart',
    exactOnline: 'Exact Online',
    shopware: 'Shopware'
}

class Customers extends Reflux.Component {
    constructor(props) {
        super(props)

        this.columnsMemo = createMemo()

        this.stores = [AdminStore]
    }

    onClickLogin(customer, event) {
        event.stopPropagation()

        LoginActions.loginAsCustomer(customer, (err) => {
            if (err) {
                this.popup.open('Foutmelding', '', () => {})
                this.popup.setError(err)
            }
        })
    }

    // The same columns until a value they read changes: new columns re-render every row of the table
    columns() {
        return this.columnsMemo([this.state.resellers, this.props.history], () => this.buildColumns())
    }

    buildColumns() {
        const {resellers} = this.state
        const {history} = this.props

        return [
            {id: 'name', title: 'Klantnaam', visible: true, flex: 1, key: 'name'},
            {id: 'reseller', title: 'Reseller', visible: true, flex: 1, key: 'reseller', text: (customer) => {
                const reseller = resellers.find((reseller) => reseller.name === customer.reseller)
                return reseller ? (reseller.settings?.accountName || reseller.name) : customer.reseller
            }},
            {id: 'address.city', title: 'Plaats', visible: true, flex: 1, key: 'address.city'},
            {
                id: 'created', title: 'Aangemaakt', visible: true, flex: 1, key: '_id', sort: (customer) => {
                    const dateFromObjectId = new Date(parseInt(customer._id.substring(0, 8), 16) * 1000)
                    return moment(dateFromObjectId).valueOf()
                }, text: (customer) => {
                    const dateFromObjectId = new Date(parseInt(customer._id.substring(0, 8), 16) * 1000)
                    return moment(dateFromObjectId).format('DD-MM-YYYY')
                }
            },
            {id: 'connections', title: 'Webshop koppelingen', visible: false, key: 'connections', width: 200, text: (customer) => {
                let connections = []

                Object.keys(customer.settings.webshops).map((webshop) => {
                    if (customer.settings.webshops[webshop]?.active) {
                        connections.push(webshopKeyToName[webshop] || webshop)
                    }
                })

                return connections.sort().join(', ')
            }, sort: (customer) => {
                let connections = []

                Object.keys(customer.settings.webshops).map((webshop) => {
                    if (customer.settings.webshops[webshop]?.active) {
                        connections.push(webshopKeyToName[webshop] || webshop)
                    }
                })

                return connections.sort().join(', ')
            }},
            {id: 'logs', title: 'Bekijk logs', visible: true, width: 75, render: (customer) => {
                return (
                    <IconButton
                        onClick={() => {
                            history?.push(`/admin/logs?customerId=${customer._id}`)
                        }}
                    >
                        <i className='mdi mdi-text-box-search-outline' />
                    </IconButton>
                )
            }},
            {id: 'login', title: 'Login', visible: true, width: 75, render: (customer) => {
                return (
                    <IconButton onClick={this.onClickLogin.bind(this, customer)}>
                        <i className='mdi mdi-login' />
                    </IconButton>
                )
            }}
        ]
    }

    async onPagination(pageSize, page) {
        const {customerName, resellerName} = this.state

        const promise = new Promise((resolve, reject) => {
            AdminActions.getCustomers(pageSize, page, {customerName, resellerName}, (err) => {
                if (!err) {
                    resolve()
                } else {
                    reject(err)
                }
            })
        })

        return promise
    }

    onChangeValue(key, event) {
        this.setState({[key]: event.target.value})
    }

    async onKeyDown(event) {
        if (event.key === 'Enter') {
            const pageSize = localStorage.getItem('_pageSize') || 40

            await this.onPagination(+pageSize, 1)
            this.table.selectPage(1)
        }
    }

    render() {
        const {customersLoading, customers, totalCustomers, customerName, resellerName} = this.state

        return (
            <div style={{display: 'flex', flexDirection: 'column', height: '100%'}}>
                <Panel style={{display: 'flex', background: Colors.backgroundNeutral, padding: '20px 10px 10px 10px'}}>
                    <Row style={{alignItems: 'baseline', columnGap: formSpacing.columnGap, marginBottom: 12}}>
                        <Input
                            value={customerName}
                            onChange={this.onChangeValue.bind(this, 'customerName')}
                            style={{width: 250}}
                            label='Klantnaam'
                            onKeyDown={this.onKeyDown.bind(this)}
                        />
                        <Input
                            value={resellerName}
                            onChange={this.onChangeValue.bind(this, 'resellerName')}
                            style={{width: 250}}
                            label='Reseller'
                            onKeyDown={this.onKeyDown.bind(this)}
                        />
                        <Button
                            icon='mdi mdi-magnify'
                            label='Zoeken'
                            onClick={() => {
                                const pageSize = localStorage.getItem('_pageSize') || 40

                                // The table only calls onPagination for the pages the user picks
                                this.onPagination(+pageSize, 1)
                                this.table?.selectPage(1)
                            }}
                        />
                    </Row>
                </Panel>

                <div style={{flex: 1, marginTop: 24, marginLeft: 24, marginRight: 24}}>
                    <Table
                        tableName='Customers'
                        columns={this.columns()}
                        rows={customers || []}
                        selectedRows={[]}
                        onPagination={this.onPagination.bind(this)}
                        totalRowsCount={totalCustomers}
                        serverSidePagination
                        loading={customersLoading}
                        ref={(ref) => this.table = ref}
                    />
                </div>

                <Popup ref={(ref) => this.popup = ref} />
            </div>
        )
    }
}

export default Customers
